import { graphqlFetch } from '@pylot-data/graphqlFetch'

import {
    stockValidationQuery,
    StockValidationInput,
    StockValidationOutput
} from './graphql/stockValidationQuery'

async function getStockValidation({
    input
}: StockValidationInput): Promise<StockValidationOutput> {
    const { data } = await graphqlFetch<
        StockValidationInput,
        StockValidationOutput
    >({
        query: stockValidationQuery,
        variables: {
            input
        }
    })

    return data
}

export default getStockValidation
